// GameInfoModal — "How to play" popup for a single side-game format.
//
// Rendered by StandaloneGamesPanel and PreRoundGamesPanel next to each
// format option. Uses useHistoryModal so Android's system back dismisses
// the popup instead of popping the SPA stack (per CLAUDE.md's hard rule —
// live scoring surfaces MUST integrate modals with browser back).
//
// Content is read from gameInfo.js — kept centralized so the two panels
// can't drift, and so a single test asserts D-278 lexicon compliance.

import useHistoryModal from '../lib/useHistoryModal'
import { getGameInfo } from '../lib/gameInfo'

export default function GameInfoModal({ format, onClose }) {
  const open = !!format
  useHistoryModal(open, onClose, `gameinfo-${format || 'none'}`)
  if (!open) return null
  const info = getGameInfo(format)
  if (!info) return null
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1400,
        background: 'rgba(0,0,0,0.72)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={`How ${info.label} works`}
        style={{
          maxWidth: 420, width: '100%',
          maxHeight: '82vh', overflowY: 'auto',
          padding: 18, borderRadius: 10,
          background: 'var(--green-deep)',
          border: '1px solid var(--gold)',
          color: 'var(--cream)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '1.05rem', color: 'var(--gold)' }}>{info.label}</h3>
            <p style={{ margin: '2px 0 0', fontSize: '0.78rem', color: 'var(--gray-300)' }}>{info.tagline}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{
              background: 'none', border: 'none', color: 'var(--gray-300)',
              fontSize: '1.4rem', cursor: 'pointer', lineHeight: 1, padding: '0 4px',
            }}
          >×</button>
        </div>
        <div style={{ marginTop: 12, display: 'grid', gap: 10 }}>
          {info.paragraphs.map((p, i) => (
            <p key={i} style={{ margin: 0, fontSize: '0.82rem', lineHeight: 1.5, color: 'var(--cream)' }}>{p}</p>
          ))}
        </div>
      </div>
    </div>
  )
}
